import { getSharedConfig } from "../../createSharedConfig"
import { getBuyRequestMeta, getSimpleForBuyRequest } from "@/js/helpers/buy-request"
import { RackOptions } from "@/js/pages/product/rackbuilder/RackTypes"
import { findBundleProduct, getAccessoryQuantity } from "@/js/pages/product/rackbuilder/utils/product-lookup"
import { getCommonAccessorySelections, getBackSelection, getFrontSelection, getJCupSelection, getDepthSelection, getPlateStorageSelection, getBandPegSelection } from "@/js/pages/product/rackbuilder/utils/selection-utils"
import { IRogue, BuyRequest } from "@/js/services/RogueTypes"

export function createTwinConfig(rogue: IRogue, buyRequest: BuyRequest): RackOptions {
  const meta = getBuyRequestMeta(buyRequest, rogue)
  const rack = findBundleProduct(rogue, buyRequest, 'rack') || getSimpleForBuyRequest(buyRequest, rogue)
  const functionalTrainer = findBundleProduct(rogue, buyRequest, 'functional trainer')
  const sharedConfig = getSharedConfig(rogue, buyRequest)
  const { trolleySelection, lowRowSelection, latBarSelection } = getCommonAccessorySelections(rogue, buyRequest, sharedConfig.materials || {})

  const is80Height = sharedConfig.height === '80'

  return {
    ...sharedConfig,
    back         : is80Height ? 'crossmember top 4' : getBackSelection(rogue, buyRequest, meta) || 'nameplate',
    front        : getFrontSelection(rogue, buyRequest, meta),
    edition      : 'twin',
    jcup         : getJCupSelection(rogue, buyRequest),
    depth        : getDepthSelection(rack, meta),
    sixPost      : true,
    plateStorage : getPlateStorageSelection(rogue, buyRequest),
    bandPegs     : getBandPegSelection(rogue, buyRequest),
    ftShrouds    : functionalTrainer?.attributes?.rig_or_wm === 'Yes',
    spotterArms  : getAccessoryQuantity(rogue, buyRequest, 'spotter arms'),
    trolleySelection,
    latBarSelection,
    lowRowSelection,
  }
}
